module.exports = __webpack_public_path__ + "img/partner-mazudivers.ec079229.png";